<div class="row mb-2" *ngIf="!somenteImplementacao">
  <div class="col-md-2 mb-2">
    <label class="mb-1">Identificador</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="identificador ? identificador : '-'" />
  </div>
  <div class="col-md-5 mb-2">
    <label class="mb-1">Status da ação</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="ciclo?.status?.descricao || '-'" />
  </div>
  <div class="col-md-5 mb-2">
    <label class="mb-1">Nível</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="ciclo?.nivelRelevancia?.descricao || '-'" />
  </div>
  <div class="col-md-12 mb-2">
    <label class="mb-1">Título</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="ciclo?.titulo || '-'" />
  </div>
  <div class="col-md-12 mb-2">
    <label class="mb-1">Descrição da ação</label>
    <div class="form-control" [innerHTML]="ciclo?.descricao"
      style="min-height: 80px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;"></div>
  </div>
  <div class="col-md-8 mb-2">
    <label class="mb-1">Responsável pela ação</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="ciclo?.responsavelNome || ciclo?.responsavelId || '-'" />
  </div>
  <div class="col-md-4 mb-2">
    <label class="mb-1">Prazo de implementação</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="(ciclo?.prazo | date:'dd/MM/yyyy') || '-'" />
  </div>
</div>

<div class="row mb-2">
  <div class="col-md-12 mb-2">
    <label class="mb-1">Descrição da Implementação da Ação</label>
    <div class="form-control" [innerHTML]="ciclo?.descricaoImplementacao"
      style="min-height: 80px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;"></div>
  </div>
  <div class="col-md-4 mb-2">
    <label class="mb-1">Data de Realização</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="(ciclo?.dataRealizacao | date:'dd/MM/yyyy') || '-'" />
  </div>
  <div class="col-md-12 mb-2">
    <label class="mb-1">Evidências da Implementação da Ação</label>
    <div class="mat-elevation-z1">
      <table class="table table-sm mb-0">
        <tbody>
          <tr *ngFor="let e of ciclo?.evidencias">
            <td>{{ e.nome }}</td>
            <td class="text-right" style="width: 70px;">
              <button type="button" class="btn btn-success btn-xs" (click)="download(e)" [disabled]="!e.evidenciaOrigemId">
                <i class="far fas fa-download"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!(ciclo?.evidencias?.length)">
            <td class="text-muted">Nenhum registro encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-md-6 mb-2">
    <label class="mb-1">Avaliação da Implementação pelo Auditor</label>
    <input type="text" class="form-control form-control-sm" readonly [value]="ciclo?.status?.descricao || '-'" />
  </div>
  <div class="col-md-12 mb-2">
    <label class="mb-1">Descrição da Avaliação da Implementação pelo Auditor</label>
    <div class="form-control" [innerHTML]="ciclo?.descricaoImplementacaoAuditor"
      style="min-height: 80px; max-height: 180px; overflow-y: auto; background-color: #e9ecef;"></div>
  </div>
  <div class="col-md-12 mb-2">
    <label class="mb-1">Evidências da Avaliação da Implementação pelo Auditor</label>
    <div class="mat-elevation-z1">
      <table class="table table-sm mb-0">
        <tbody>
          <tr *ngFor="let e of ciclo?.evidenciasAuditor">
            <td>{{ e.nome }}</td>
            <td class="text-right" style="width: 70px;">
              <button type="button" class="btn btn-success btn-xs" (click)="downloadAuditor(e)" [disabled]="!e.evidenciaOrigemId">
                <i class="far fas fa-download"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!(ciclo?.evidenciasAuditor?.length)">
            <td class="text-muted">Nenhum registro encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-md-6 mb-2">
    <label class="mb-1">Responsável da avaliação</label>
    <input type="text" class="form-control form-control-sm" readonly
      [value]="ciclo?.responsavelNomeMonitoramento || ciclo?.responsavelIdMonitoramento || '-'" />
  </div>
  <div class="col-md-6 mb-2">
    <label class="mb-1">Data e hora da avaliação</label>
    <input type="text" class="form-control form-control-sm" readonly
      [value]="(ciclo?.dataMonitoramento | date:'dd/MM/yyyy HH:mm') || '-'" />
  </div>
</div>
